import { Redirect } from "react-router-dom";
import { RedirectProps } from "react-router";
import useQuery from "utils/hooks/useQuery";

interface RedirectWithQueryProps extends RedirectProps {
  to: string;
  queryKeysToDelete?: string[];
}

const RedirectWithQuery = ({
  to,
  queryKeysToDelete,
  ...props
}: RedirectWithQueryProps) => {
  const currentSearchParams = useQuery();

  const getParsedUrl = (url: string) => {
    try {
      return new URL(url);
    } catch (e) {
      return null;
    }
  };

  let parsedDestUrl = getParsedUrl(to);
  if (!parsedDestUrl) {
    const destUrl = `${window.location.origin}${to}`;
    parsedDestUrl = getParsedUrl(destUrl);
  }

  let dest: string | { pathname: string; search: string } = to;
  if (parsedDestUrl) {
    try {
      const updatedSearchParams = {
        ...Object.fromEntries(currentSearchParams),
        ...Object.fromEntries(parsedDestUrl.searchParams),
      };
      queryKeysToDelete?.forEach(
        (queryKey) => delete updatedSearchParams[queryKey]
      );
      dest = {
        pathname: parsedDestUrl.pathname,
        search: new URLSearchParams(updatedSearchParams).toString(),
      };
    } catch (e) {}
  }

  return <Redirect to={dest} {...props} />;
};

export default RedirectWithQuery;
